<template>
  <form
    ref="meetingSubmitForm"
    class="invisible-form"
    :action="action"
    method="POST"
  >
    <input
      type="hidden"
      name="bandwidth"
      :value="bandwidth"
    >
    <input
      type="hidden"
      name="exiturl"
      :value="exiturl"
    >
    <input
      type="hidden"
      name="room"
      :value="room"
    >
    <input
      type="hidden"
      name="dname"
      :value="dname"
    >
    <input
      v-if="pin"
      type="hidden"
      name="roompin"
      :value="pin"
    >
    <input
      v-if="kiosk"
      type="hidden"
      name="kiosk"
      :value="true"
    >
  </form>
</template>

<script>
export default {
  name: 'MeetingSubmitForm',
  props: {
    action: {
      type: String,
      default: ''
    },
    bandwidth: {
      type: [String, Number],
      default: 1024
    },
    exiturl: {
      type: String,
      default: null
    },
    room: {
      type: [String, Number],
      default: ''
    },
    dname: {
      type: String,
      default: ''
    },
    pin: {
      type: String,
      default: null
    },
    kiosk: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submitToMeeting () {
      if (this.$refs.meetingSubmitForm) {
        this.$refs.meetingSubmitForm.submit();
      }
    }
  }
};
</script>
